import LocationSelect2 from "./LocationSelect2";

// Reexport under "LocationSelect" for legacy imports
export default LocationSelect2